<div>
  <!-- <div class="inputargumentspace" *ngIf="!manualTrigger && !manualTriggerRes">
    <mat-card-title>Input and arguments</mat-card-title>
  </div> -->
  <div class="example-container" [ngClass]="{'maxHeightCondition': manualTrigger || manualTriggerRes}">
    <form [formGroup]="inputArgForm" autocomplete="off">
      <ng-container formArrayName="inputGroupArray">
        <table mat-table [dataSource]="inputGroupArray.controls" class="mat-elevation-z8">
          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef>Key</th>
            <td mat-cell *matCellDef="let element"> {{element.get('key').value}} </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.get('description').value}} </td>
          </ng-container>

          <ng-container matColumnDef="payload">
            <th mat-header-cell *matHeaderCellDef> Payload </th>
            <td mat-cell *matCellDef="let element;" [formGroup]="element"> <mat-checkbox color="primary"
                formControlName="isSelected" (change)="checkboxChanged(element)"></mat-checkbox> </td>
          </ng-container>


          <ng-container matColumnDef="default">
            <th mat-header-cell *matHeaderCellDef> Value </th>
            <div class="tr-width">
              <td mat-cell *matCellDef="let element;let i = index;" [formGroup]="element">
                <div *ngIf="!element.get('isSelected').value">
                  <div fxLayoutAlign="start center" *ngIf="element.get('value').value != 'target_drop'"
                    class="table-form-field" fxLayoutGap="0.5rem">
                    <mat-form-field class="wd-85 input-space"
                      [ngClass]="{ 'disabled-cursor': inputArgForm.disabled}">
                      <mat-label [ngClass]="{'disabled-cursor': inputArgForm.disabled}">Enter value</mat-label>
                      <input matInput type="text" formControlName="value" 
                        [ngClass]="{'disabled-cursor': inputArgForm.disabled}" [readonly]="element.get('readOnly').value">
                    </mat-form-field>
                    <!-- <mat-form-field class="wd-85 input-space" *ngIf="element.get('key').value == 'runner_details'"
                      [ngClass]="{ 'disabled-cursor': !element.get('editClicked')}">
                      <mat-label [ngClass]="{'disabled-cursor': !element.get('editClicked')}">Enter value</mat-label>
                      <input matInput [disabled]="true" type="text" [value]="runnertext"
                        [ngClass]="{'disabled-cursor': !element.get('editClicked')}" required>
                      <mat-icon matSuffix class="mat-icon-color cursor"
                        [id]="tourGuidIds.configBuilder.workflow.runnerDetailEdit.id" *ngIf="mode !== 'read'"
                        (click)="edit(element.value,i)" [matTooltip]="editIcon">mode_edit</mat-icon>
                    </mat-form-field> -->
                  </div>
                </div>
                <div fxLayoutAlign="start center" *ngIf="element.get('isSelected').value && !manualTrigger"
                  class="table-form-field" fxLayoutGap="0.5rem">
                  <!-- dynamic dropdown component -->
                  <app-dynamic-dropdown [targetMenu]="'Payload'" [data]="dpService.dataMap" [isRootNode]="true"
                    [isSelect]="true" [childFormControl]="element.get('value')" class="wd-85" [title]="'Payload'"
                    [placeholder]="'Select value'">
                  </app-dynamic-dropdown>
                </div>
              </td>
            </div>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <!-- No data available -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan=9>
              <app-no-data-available [newData]="getNoData"></app-no-data-available>
            </td>
          </tr>
        </table>
      </ng-container>
    </form>
  </div>
</div>